package game.entity

import game.Game
import game.Room

class WalkerTemplate(val speed: Int, val damage: Int)

class Walker(hp: Int = 1, damage: Int = 1, speed: Int = 20, private val spriteId: String = "mushroom") : Enemy(hp, damage) {
    private val wanderComponent = WanderComponent(speed, false)

    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById(spriteId)
    }

    override fun onTick(game: Game, room: Room) {
        wanderComponent.tick(game, room, this)
    }
}